/**
 * The "More / Less" toggle on a testimonial cell.
 *
 * The four-line cap is visual — the whole quote is in the DOM — so overflow is the only
 * way to tell whether one was actually cut. Measured from the laid-out box rather than
 * guessed from the string length, which says nothing about where the lines break.
 *
 * Binds to every [data-quote-clamp] container on the page, so a rail, a stacked sidebar
 * and the full catalogue all work without any of them shipping a script of their own.
 * Labels ride on the button as data- attributes because this file is compiled and cannot
 * reach Blade's translator.
 */
(function () {
    'use strict';

    /** Cells hidden by a rail's limit report zero height, so they measure as "not cut". */
    function sync(container) {
        container.querySelectorAll('.rail-cell__body').forEach(function (body) {
            var quote = body.querySelector('.rail-cell__quote');
            var btn = body.querySelector('[data-quote-more]');

            // An opened quote no longer overflows, and re-measuring it would take its own
            // toggle away.
            if (!quote || !btn || quote.classList.contains('is-open')) {
                return;
            }

            btn.classList.toggle('is-needed', quote.scrollHeight > quote.clientHeight + 1);
        });
    }

    function syncAll() {
        document.querySelectorAll('[data-quote-clamp]').forEach(sync);
    }

    function bind(container) {
        container.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-quote-more]');
            if (!btn) {
                return;
            }

            var quote = btn.closest('.rail-cell__body').querySelector('.rail-cell__quote');
            var label = btn.querySelector('[data-quote-more-label]');
            var open = quote.classList.toggle('is-open');

            // aria-expanded also turns the chevron over — see _quote-rail.scss.
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');

            if (label) {
                label.textContent = open
                    ? (btn.dataset.labelLess || 'Less')
                    : (btn.dataset.labelMore || 'More');
            }
        });

        // Expanding narrows or widens the cell, so a quote that was cut in the rail can fit
        // in the grid and vice versa — measured once, the toggle would sit there pointing at
        // text that is no longer hidden. It also reveals the cells held back by a limit,
        // which have never been measured at all. The expand control belongs to card-rail, so
        // watch the class the track itself carries instead of reaching for it; scrolling
        // writes to that same attribute, hence the state check.
        var track = container.querySelector('.rail') || container;
        var wasExpanded = track.classList.contains('rail--expanded');

        new MutationObserver(function () {
            var isExpanded = track.classList.contains('rail--expanded');
            if (isExpanded === wasExpanded) {
                return;
            }
            wasExpanded = isExpanded;
            sync(container);
        }).observe(track, { attributes: true, attributeFilter: ['class'] });

        sync(container);
    }

    function start() {
        document.querySelectorAll('[data-quote-clamp]').forEach(bind);

        var ticking = false;
        window.addEventListener('resize', function () {
            if (ticking) {
                return;
            }
            ticking = true;
            requestAnimationFrame(function () {
                syncAll();
                ticking = false;
            });
        });

        // The webfont moves the line breaks, so a measurement taken before it lands can
        // miss a cut — or invent one.
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(syncAll);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();
